module.exports = __webpack_public_path__ + "static/media/studynightOp.48baa0c1.png";